import { WifiOff, X } from 'lucide-react';

interface OfflineBannerProps {
  visible: boolean;
  onDismiss: () => void;
}

export function OfflineBanner({ visible, onDismiss }: OfflineBannerProps) {
  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white px-4 py-2 shadow-md">
      <div className="flex items-center justify-center gap-2 max-w-7xl mx-auto">
        <WifiOff className="h-4 w-4 flex-shrink-0" />
        <p className="text-sm font-medium">
          You&apos;re offline &mdash; changes will sync when reconnected
        </p>
        <button
          type="button"
          onClick={onDismiss}
          className="ml-4 p-0.5 rounded-full hover:bg-amber-600 transition-colors"
          aria-label="Dismiss offline banner"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
